<template>
    <div id="app">
        <PatientNotes :Mode="'View'" :Type="AppServiceID"/>
    </div>
</template>

<script>
import Vue from 'vue';
import PatientNotes from '@/components/DPEBB/Administrator/PatientNotes.vue'  
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';

export default {

  data: function (){
        return {
        AppServiceID :'',
        }
    },
    components: { 
        PatientNotes
    },
created: function() { 
    this.$emit('update:layout', LayoutDefault);
    this.AppServiceID= this.$store.getters.GetMedicalID; 
},    
beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetMedicalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetMedicalID);
    },

}
</script>

<style>

</style>
